import { useEffect, useState } from "react";
import { createContext } from "react";
import { getGoldPrice, updateGoldPrice } from "../helpers/http_gold_price_requests";
import { clearNonNumericCharacters } from "../utils/functions";
// Removido import Typography
import { useAuth } from "./AuthProvider";
import { getSilverPrice, updateSilverPrice } from "../helpers/http_silver_price_requests";
import globalToast from "../components/common/globalToast";
import { getLaborPrice, updateLaborPrice } from "../helpers/http_labor_requests";

export const GoldPriceContext = createContext({});

function GoldPriceProvider({ children }) {
    const [currentGoldPrice, setCurrentGoldPrice] = useState(0);
    const [currentSilverPrice, setCurrentSilverPrice] = useState(0);
    const [currentLaborPrice, setCurrentLaborPrice] = useState(0);

    const { id } = useAuth();

    async function updateCurrentGoldPrice(value) {

        var cleanPrice = clearNonNumericCharacters(value);

        if (cleanPrice == currentGoldPrice) {

            return null;

        } else if (cleanPrice <= 10000) {

            globalToast.error(
                "O valor deve ser maior ou igual a R$ 100,00"
            );
            return null;

        } else {

            await updateGoldPrice(cleanPrice, setCurrentGoldPrice);

            return null;

        };

    };

    async function updateCurrentSilverPrice(value) {

        var cleanPrice = clearNonNumericCharacters(value);

        if (cleanPrice == currentSilverPrice) {

            return null;

        } else if (cleanPrice <= 400) {

            globalToast.error(
                "O valor deve ser maior ou igual a R$ 4,00"
            );
            return null;

        } else {

            await updateSilverPrice(cleanPrice, setCurrentSilverPrice);

            return null;

        };

    };

    async function updateCurrentLaborPrice(value) {

        var cleanPrice = clearNonNumericCharacters(value);

        if (cleanPrice == currentLaborPrice) {

            return null;

        } else if (cleanPrice <= 2500) {

            globalToast.error(
                "O valor deve ser maior ou igual a R$ 25,00"
            );
            return null;

        } else {

            await updateLaborPrice(cleanPrice, setCurrentLaborPrice);

            return null;

        };

    };


    useEffect(() => {

        if (Boolean(id)) {

            getGoldPrice(setCurrentGoldPrice);
            getSilverPrice(setCurrentSilverPrice);
            getLaborPrice(setCurrentLaborPrice);
        }

    }, [id]);

    return (
        <GoldPriceContext.Provider
            value={{
                currentGoldPrice,
                currentSilverPrice,
                currentLaborPrice,
                updateCurrentGoldPrice,
                updateCurrentSilverPrice,
                updateCurrentLaborPrice
            }} >
            {children}
        </GoldPriceContext.Provider>
    );
}

export default GoldPriceProvider;
